import TableContracts from "./TableContracts";

export default TableContracts;
